import "../Sass/main.scss"

import Base from "./app/Base/base";

let base = new Base();
base.init();